import { RecordCreateScreen } from "@/lib/Components/Screens/RecordScreen/RecordCreateScreen";
import { RecordCreateCard } from "@/lib/Components/SideBarList/Cards/RecordCreateCard";
import { CreateSupplierInput, Currency, HireUnitType } from "@/gql/graphql";
import { useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createSupplierMutation } from "@/app/Suppliers/GraphQL/supplierMutations";
import { TextInput } from "@/lib/Components/Form/Inputs/TextInput";
import { OrganisationInput } from "@/app/Organisations/Components/OrganisationInput";
import { FormDivider } from "@/lib/Components/Form/Components/FormDivider";
import { HireUnitTypeInput } from "@/app/Common/Components/HireUnitType";
import { CurrencyTypeInput } from "@/app/Common/Components/CurrencyTypeInput";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { useTranslations } from "use-intl";

const validation = z.object({
  name: z.string().min(1),
});

export function SupplierCreateScreen() {
  const navigate = useNavigate();
  const { mutateAsync } = useGqlMutation(createSupplierMutation);
  const { isAdmin } = useTenant();
  const t = useTranslations("supplier.create");

  return (
    <RecordCreateScreen>
      <RecordCreateCard<CreateSupplierInput>
        title={t("title")}
        validationSchema={toFormikValidationSchema(validation)}
        initialValues={{
          name: "",
          hire_unit_type: HireUnitType.Day,
          currency: Currency.Aud,
        }}
        onSubmit={async (values) => {
          const res = await mutateAsync({
            input: values,
          });

          await navigate({
            from: "/$tenant/$orgId/supplier/{-$supplierId}",
            to: "/$tenant/$orgId/supplier/{-$supplierId}/settings",
            params: (prev) => prev,
            search: { supplier: res.createSupplier.id },
          });
        }}
      >
        {isAdmin ? (
          <OrganisationInput name="managed_by_id" label={t("organisation")} />
        ) : null}

        <TextInput name="name" label={t("name")} className="col-span-4" />

        <FormDivider />
        <CurrencyTypeInput
          name="currency"
          label={t("currency")}
          className="col-span-4"
        />
        <HireUnitTypeInput
          name="hire_unit_type"
          label={t("unit")}
          className="col-span-4"
        />
      </RecordCreateCard>
    </RecordCreateScreen>
  );
}
